<template>
  <div class="dup__media__call__btn">
    <b-button
      @click="duplicateMediaCallFromProject"
      v-b-tooltip.hover
      title="Duplicate"
      class="duplicate-media-call-btn"
      variant="theme"
    >
      <i class="fas fa-copy"></i>
    </b-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ['deliverableId', 'namespace', 'deliverableTemplateId'],
  computed: {
  	...mapState({
    state (state) {
      return state[this.namespace]
    },
    getDeliverableTemplateSlug (state, getters) {
      return getters['getDeliverableTemplateSlug']
    },
  	}),
  },
  methods: {
    duplicateMediaCallFromProject() {
      let that = this;

       let slug = "";

       if (this.deliverableTemplateId) {
      	 slug = this.getDeliverableTemplateSlug(this.deliverableTemplateId);
      	}

	      	if (slug == "organic-social-media-plan") {
	      		that.$root.$emit('openDuplicateDeliverableModal', {deliverableId:this.deliverableId});
	      	} else {
	      		this.$store.dispatch(this.namespace + 'duplicateMediaCallFromProject', {deliverableId: this.deliverableId}).then(function() {
	      		  that.$store.dispatch(that.namespace + 'fetchDeliverables').then(function() {
	      		  	that.$store.dispatch(that.namespace + 'fetchProjectDeliverable').then(function() {
	      		    	that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable duplicated.');
	      		    });
	      		  });
	      		  that.$bvModal.hide("editDeliverableModal");
	      		  window.scrollTo(0, 0);
	      		});
		      }






    },
  },
};
</script>

<style>
</style>